import FullWidthHeader from "@components/BasicComponents/FullWidthHeader/FullWidthHeader"
import FullWidthHeaderAdvanced from "@components/BasicComponents/FullWidthHeader/FullWidthHeaderAdvanced"
import SocialResponsibilityContactFormSection from "@components/Pages/SocialResponsibility/SocialResponsibilityForm/SocialResponsibilityContactFormSection"
import HeadMeta from "@components/Theme/HeadMeta/HeadMeta"
import {getPosts} from "@config/modules"
import getValueOrThrow from "@helpers/getValueOrError"
import {getTranslatedPageData} from "@hooks/PagesData/getTranslatedPageData"
import CustomerStories from "@jsons/customerStories.json"
import CustomerIndustries from "@jsons/customerStoriesIndustries.json"
import Logos from "@jsons/customerStoriesLogos.json"
import CustomerStoriesPage from "@jsons/customerStoriesPage.json"
import CustomerUseCases from "@jsons/customerStoriesUseCases.json"
import CustomerHeaderSection from "@pages/CustomerStories/CustomerStoryHeader/CustomerHeaderSection"
import LogoSlider from "@pages/CustomerStories/CustomerStoryLogo/LogoSlider"
import PinnedStories from "@pages/CustomerStories/CustomerStoryPinnedStories/PinnedStories"
import CustomerStoriesVerticalList from "@pages/CustomerStories/CustomerStoryVerticalList/CustomerStoriesVerticalList"
import React from "react"

type Props = {}

const index = (props: Props): JSX.Element => {
	const pageData = getTranslatedPageData(CustomerStoriesPage, true, true)
	const CustomerStoriesPageSections = getValueOrThrow(
		pageData.AdvancedSideAsset,
	)

	const stories = getPosts("CustomerStoriesModule", {data: CustomerStories})
	const logos = getPosts("logosModule", {data: Logos})

	const translatedUseCases = getPosts("CategoriesModule", {
		data: CustomerUseCases,
	})
	const translatedIndustries = getPosts("CategoriesModule", {
		data: CustomerIndustries,
	})
	const hero = getValueOrThrow(pageData.heroData?.[0])

	return (
		<>
			<HeadMeta
				meta={pageData.metaData}
				customPath="/inspiration/customer-stories"
			/>
			<FullWidthHeaderAdvanced data={hero} withOverlay />

			{/* <FullWidthHeader
				data={{
					title: CustomerStoriesPageSections[0]?.sectionTitle,
					subtitle: CustomerStoriesPageSections[0]?.sectionSubtitle,
				}}
				position={"left"}
				size={"L"}
			/> */}
			<CustomerHeaderSection
				data={
					getValueOrThrow(
						CustomerStoriesPageSections[0].mainContent,
					)[0]
				}
			/>
			<LogoSlider content={CustomerStoriesPageSections[1]} data={logos} />

			<PinnedStories
				data={CustomerStoriesPageSections[2]}
				stories={stories}
			/>

			<CustomerStoriesVerticalList
				data={stories}
				industries={translatedIndustries}
				pageData={CustomerStoriesPageSections[3]}
				useCases={translatedUseCases}
			/>

			{/* <CustomerStoriesFormSection data={CustomerStoriesPageSections[4]} /> */}
			<SocialResponsibilityContactFormSection />
		</>
	)
}

export default index
